import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';

export default function Garantia() {
  return (
    <>
      <Helmet>
        <title>Garantía | Innotec Food Equipment</title>
        <meta name="description" content="Condiciones de garantía de Innotec Food Equipment para maquinaria nueva y de segunda mano" />
      </Helmet>

      <div className="max-w-5xl mx-auto px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <h1 className="text-4xl font-bold mb-6 text-white">Garantía</h1>
          <div className="h-1 w-24 bg-[#FCAA0D]"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="prose prose-lg prose-invert max-w-none"
        >
          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Garantía Maquinaria Nueva</h2>
            <h3 className="text-xl font-bold mt-6 mb-4 text-white">CONDICIONES GENERALES DE LA GARANTÍA DE MAQUINARIA NUEVA</h3>

            <ol className="list-decimal pl-6 space-y-4">
              <li>
                Toda maquinaria nueva tendrá la garantía ofrecida por el fabricante y detallada en la documentación adjunta a la máquina. Por lo general,
                la garantía del fabricante de maquinaria industrial cubre durante el plazo de un año a partir de la fecha de recepción de la máquina.
                Será el Servicio Técnico Oficial del fabricante el único responsable de la ejecución de la garantía, no teniendo <strong>Innotec Food Equipment S.L.</strong>
                (en adelante, <strong>Innotec</strong>) responsabilidad alguna desde el momento de su venta y comprobación de funcionamiento en nuestras instalaciones.
              </li>
              <li>
                La garantía solo ampara defectos de fabricación y piezas defectuosas, las cuales se canjearán una vez verificadas.
              </li>
              <li>
                EXCLUSIONES DE LA GARANTÍA – Queda excluido de la cobertura de la garantía, y por tanto será a cargo del usuario el coste de las horas
                de la reparación, transporte y desplazamiento, en los siguientes casos:
                <ul className="list-decimal pl-6 mt-2 space-y-2">
                  <li>Las averías provocadas por negligencia o mal uso del aparato por parte del consumidor.</li>
                  <li>Las averías producidas por causas de caso fortuito, fuerza mayor (fenómenos atmosféricos o geológicos) y siniestros.</li>
                  <li>Las intervenciones que se deriven de una instalación incorrecta o de la falta de mantenimiento.</li>
                  <li>La aplicación de productos químicos inadecuados o la acumulación de residuos, tales como grasa o cal, originada por falta de limpieza.</li>
                  <li>La ubicación incorrecta de la máquina.</li>
                  <li>Los desgastes o deterioros estéticos producidos por el uso.</li>
                </ul>
              </li>
              <li>
                El servicio de instalación, mano de obra, reparación o mantenimiento posterior correrá a cargo del comprador exclusivamente.
              </li>
              <li>
                La garantía únicamente se responsabiliza de materiales o piezas, no haciéndose cargo en ningún caso de indemnización alguna.
              </li>
              <li>
                Los materiales de reposición se enviarán siempre por cuenta y riesgo del comprador, y serán facturados al mismo.
              </li>
              <li>
                Sustituida la pieza, el comprador remitirá la defectuosa a la empresa vendedora para verificar la avería y validar la garantía con el
                fabricante.
              </li>
              <li>
                Una vez verificado, <strong>Innotec</strong> hará el abono correspondiente y la devolución del dinero al comprador.
              </li>
            </ol>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Garantía Máquinas de segunda mano</h2>
            <h3 className="text-xl font-bold mt-6 mb-4 text-white">CONDICIONES GENERALES DE LA GARANTÍA DE MAQUINARIA DE SEGUNDA MANO</h3>

            <p>
              Todas las máquinas reacondicionadas tendrán una garantía de 3 meses.
              Este plazo de la garantía aparecerá perfectamente detallado en las <strong>Condiciones de Venta</strong> indicadas en nuestra web <a href="https://www.innotecfood.com" target="_blank" rel="noopener noreferrer" className="text-[#FCAA0D] hover:underline">www.innotecfood.com</a> y que el cliente acepta con su firma en el presente documento.
            </p>

            <p>
              El responsable único de la comprobación del estado de la maquinaria a su recepción será el cliente en todos los casos. La firma del albarán
              de entrega conllevará la aceptación total del estado de la maquinaria y todos sus componentes anexos, si les hubiera.
            </p>

            <p>
              <strong>Innotec</strong> ofrece a todos sus clientes una prueba gratuita en nuestras instalaciones con anterioridad al compromiso de compra con el fin de
              verificar el correcto funcionamiento y estado de la maquinaria. El hecho de que el cliente no desee realizar esta prueba exime a <strong>Innotec</strong> de
              cualquier tipo de reclamación posterior al respecto.
            </p>

            <p className="font-bold">
              EXCLUSIONES DE LA GARANTÍA – Queda excluido de la cobertura de la garantía, y por tanto será a cargo del cliente el coste de la reparación,
              en los siguientes casos:
            </p>

            <ol className="list-decimal pl-6 space-y-2">
              <li>Las averías provocadas por negligencia o mal uso del aparato por parte del consumidor.</li>
              <li>Las averías producidas por causas de caso fortuito, fuerza mayor (fenómenos atmosféricos o geológicos) y siniestros.</li>
              <li>Las intervenciones que se deriven de una instalación incorrecta o de la falta de mantenimiento.</li>
              <li>La aplicación de productos químicos inadecuados o la acumulación de residuos, tales como grasa o cal, originada por falta de limpieza.</li>
              <li>La ubicación incorrecta de la máquina.</li>
              <li>
                Los desgastes o deterioros estéticos producidos por el uso, así como los no detectados por el cliente con anterioridad a la
                firma del Presupuesto Vinculante, factura proforma o cualquier otro documento de compromiso firmado por ambas partes antes
                de que la máquina adquirida salga de nuestros almacenes.
              </li>
              <li>
                El cliente asume y rubrica con su firma o sello que no ha lugar a la devolución de los importes abonados en
                concepto de adelantos, señales, fianzas, etc, en los supuestos reflejados en este epígrafe, así como en los casos de
                superar el plazo acordado para la recepción de la maquinaria por motivos ajenos a <strong>Innotec.</strong> Tampoco habrá lugar a
                devolución en el caso de desistimiento por parte del cliente de completar el pago de los importes pendientes.
              </li>
            </ol>

            <p className="mt-4">
              El servicio de instalación, mano de obra, reparación o mantenimiento posterior correrá exclusivamente por parte del comprador.
              La garantía únicamente se responsabiliza de materiales o piezas, no haciéndose cargo en ningún caso de indemnización alguna.
              Los materiales de reposición se enviarán siempre por cuenta y riesgo del comprador, y serán facturados al mismo.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="text-2xl font-bold mb-4 text-[#FCAA0D]">Información adicional importante</h2>

            <p>
              Por la presente, queremos informar a nuestros valiosos clientes que los desplazamientos y las dietas de nuestros técnicos hacia las instalaciones de su empresa no están amparados por la garantía de productos y servicios de <strong>Innotec</strong>. Para garantizar la correcta evaluación de cualquier posible defecto o problema en su equipo, solicitamos que el artículo sea remitido a nuestras instalaciones para una revisión detallada y determinar si el mismo se encuentra dentro de los términos de garantía. Por favor, tenga en cuenta que tanto los gastos de transporte de ida como de vuelta no estarán cubiertos por la garantía y deberán ser asumidos por el cliente. Esta política busca asegurar una evaluación precisa y justa de su equipo, al tiempo que garantiza la transparencia en los costos asociados al servicio.
            </p>

            <p className="mt-4">
              Además, es de suma importancia que el equipo sea enviado en condiciones seguras. Para ello, le recomendamos encarecidamente solicitar un manual de paletización y transporte a <strong>Innotec</strong>. Este manual proporciona instrucciones detalladas sobre cómo preparar el producto de forma adecuada para evitar cualquier daño durante el transporte del mismo. La colaboración en este aspecto es fundamental para garantizar que el equipo llegue a nuestras instalaciones en óptimas condiciones.
            </p>

            <p className="mt-4">
              Para la puesta en marcha de la máquina, se realizará con videollamada desde el servicio técnico de <strong>INNOTEC</strong>, dándole instrucciones sobre la puesta en marcha, en el caso que la puesta en marcha se haga sin la videollamada de <strong>Innotec</strong> no nos responsabilizamos y la garantía resultaría cancelada.
            </p>

            <p className="mt-4">
              En ningún caso se dará garantía en la maquinaria cuyo transporte e instalación no haya sido gestionado íntegramente por <strong>Innotec,</strong> siempre y cuando la máquina vaya durante el transporte debidamente paletizada y embalada.
            </p>

            <p className="mt-6 font-bold">
              Para cualquier cuestión relativa a la interpretación, cumplimiento o incumplimiento de la presente compraventa, las partes con renuncia al fuero propio que pudiera corresponderles, se someten expresamente a los juzgados y tribunales de Palencia.
            </p>
          </section>
        </motion.div>
      </div>
    </>
  );
}
